import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useSuiteStore } from '@/stores/useSuiteStore'

export interface BoostCoreUserItem {
  uuid: string
  email: string
  firstName: string | null
  lastName: string | null
  status: string
}

export const useBoostCoreUsersStore = defineStore('boostCoreUsers', () => {
  const suiteStore = useSuiteStore()
  const users = ref<BoostCoreUserItem[]>([])
  const isLoading = ref(false)

  async function fetchUsers(): Promise<BoostCoreUserItem[]> {
    isLoading.value = true
    try {
      const res = await suiteStore.suiteFetch('users?limit=500', {
        method: 'GET',
        credentials: 'include',
      })
      if (res && typeof res !== 'boolean' && res.ok) {
        const json = await res.json()
        const list = Array.isArray(json?.data) ? json.data : (json?.data ? [json.data] : [])
        users.value = list
        return users.value
      }
    } catch (e) {
      console.error('Erreur récupération utilisateurs boostcore', e)
    } finally {
      isLoading.value = false
    }
    return []
  }

  function getUserLabel(u: BoostCoreUserItem): string {
    const name = [u.firstName, u.lastName].filter(Boolean).join(' ')
    return name || u.email
  }

  return {
    users,
    isLoading,
    fetchUsers,
    getUserLabel,
  }
})
